export interface SocialLink {
  name: string;
  href: string;
}

export const socialTags = [
  { name: "GitHub", href: "https://github.com/AshanMSilva" },
  { name: "LinkedIn", href: "https://linkedin.com/in/ashan-m-silva" },
  { name: "Instagram", href: "https://www.instagram.com/ashan_m_silva/" },
];
